export const getI18nPrefix = (lang, isDefaultLang) =>
  isDefaultLang ? '' : `/${lang}`;

export const getI18nUrl = (lang, isDefaultLang) =>
  isDefaultLang ? '/' : `/${lang}`;

export const getI18nPrefixedSlug = (slug, lang, isDefaultLang) =>
  `${isDefaultLang ? '' : `/${lang}`}/${slug}`;
